/**
 * iconName -> string =  nome do icon
 * color -> string = cor fundo do icone
 * classColor -> string = string de cor fundo do icone
 * title -> string = titulo
 * content -> string = conteudo
 * _className -> string = classe customizada
 */
import React from "react";
import './CardVision.css'
import getImage from "../../useFull/getImage";

const CardVision = props => {
    const { iconName, color, title, content, classColor, _className } = props
    const img = getImage('icons', iconName);

    return (
        <div className={`card-vision-container ${_className}`}>
            <div className={`card-vision-icon-container ${classColor || 'gray100'}`} style={{ 
                ...(color ? { backgroundColor: color } : {})
                }}>
                <div style={{ backgroundImage: `url(${img})`, width: '90px'}} className='bg-icon' />
            </div>
            <span className="text-title-secondary">{title}</span>
            <span dangerouslySetInnerHTML={{ __html: content }}></span>
        </div>
    )
}

export default CardVision